export default "__VITE_PUBLIC_ASSET__e25802d6__"